import { postRequest } from '../clients/axios';
import { DeleteImageMetadataPayload, DeleteImageMetadataResponse } from '../models/ImageMetadata';

export const postDeleteImageMetadata = async (payload: DeleteImageMetadataPayload) => {
  const response = await postRequest<DeleteImageMetadataResponse>('storageObject/image/deleteMetadata', payload);
  return response.data;
};
